require('./views');
require('./bootstrap')

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueTelInput from 'vue-tel-input'
import CKEditor from '@ckeditor/ckeditor5-vue'
import './assets/sass/app.scss';

Vue.config.productionTip = false

Vue.use(CKEditor);
Vue.use(VueTelInput, {
  autoFormat: true,
  defaultCountry: 'KE',
  onlyCountries: ['KE'],
  mode: 'international',
  dropdownOptions: {
    width: '320px',
    required: true,
    showDialCodeInList: false
  },
  inputOptions: {
    placeholder: 'Phone number'
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
